export default class dateValidator {
    constructor() {
    }

    validate(value, minimumAge, countryCode) {
        const dateSplit = value.split('-');
        let date = '';

        switch (countryCode) {
            //YMD > DMY
            case 'hu':
            case 'jp':
            case 'hk':
            case 'kr':
            case 'tw':
            case 'lt':
                date = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
                break;

            //MDY > DMY
            case 'us':
            case 'ph':
                date = `${dateSplit[1]}-${dateSplit[0]}-${dateSplit[2]}`;
                break;

            //DMY
            default:
                date = value;
                break;
        }

        /**
         * Match the date
         */
        if(date.match(/^(((0[1-9]|[12][0-9]|3[01])-(0[13578]|1[02])-((19|[2-9][0-9])[0-9]{2}))|((0[1-9]|[12][0-9]|30)-(0[13456789]|1[012])-((19|[2-9][0-9])[0-9]{2}))|((0[1-9]|1[0-9]|2[0-8])-02-((19|[2-9][0-9])[0-9]{2}))|(29-02-((1[6-9]|[2-9][0-9])(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/)) {

            // Create the minimum age date
            let minimumAgeDate = new Date();
            minimumAgeDate.setFullYear(minimumAgeDate.getFullYear() - minimumAge);

            // Set the user date to the correct format to compare
            let userDateSplit = date.split('-');
            let userDate = new Date(userDateSplit[2], (userDateSplit[1] - 1), userDateSplit[0]);

            //Compare dates to see if it's old enough
            if(minimumAgeDate.getTime() >= userDate.getTime()) {
                return true;
            }
        }

        return false;
    }
}
